import { log } from '@shared/log.browser.ts';
import tracking from '@shared/tracking/Tracking.browser';
import type { KnownTrackingLabels } from '@shared/tracking/TrackingLabels';

export default {
    /**
 *
 *
 */
    trackInteraction(interaction: KnownTrackingLabels['san_Interaction']) {
        log.debug(`trackInteraction -- san_Interaction: ${interaction}`);
        tracking.submitEvent({ san_Interaction: interaction });
    },
};
